import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDress = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.8841 6.86784L8.75503 4.79338V2.62582C8.75503 2.27991 8.47512 2 8.1292 2C7.78329 2 7.50338 2.27991 7.50338 2.62582V4.98125L6.74006 6.50848C6.38742 7.21314 6.38925 8.05348 6.74433 8.75692L7.46956 10.1919L5.01477 21.2385C4.97382 21.4243 5.01905 21.6174 5.13761 21.7653C5.25679 21.9144 5.43585 22 5.62592 22H18.143C18.333 22 18.5121 21.9144 18.6313 21.7653C18.7498 21.6174 18.7951 21.4243 18.7541 21.2385L16.2992 10.1913L17.0241 8.75692C17.3792 8.05348 17.3811 7.21314 17.0284 6.50848L16.2649 4.98085V2.62582C16.2649 2.27991 15.985 2 15.6391 2C15.2931 2 15.0132 2.27991 15.0132 2.62582V4.79348L11.8843 6.86784H11.8841ZM11.8843 8.24477C12.0047 8.24477 12.1251 8.20993 12.2302 8.14026L15.3954 6.04156L15.9088 7.0683C16.0854 7.42094 16.0848 7.8408 15.9069 8.19221L15.2542 9.48358H8.51424L7.86152 8.19221C7.68367 7.8408 7.68306 7.42094 7.85968 7.0683L8.37306 6.04156L11.5382 8.14026C11.6433 8.20993 11.7637 8.24477 11.8841 8.24477H11.8843ZM6.40636 20.7484L8.63096 10.7352H15.1379L17.3625 20.7484H6.40636Z",
		fill: "currentColor"
	})
});
export default SvgDress;
